import { FC } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
  } from '@mui/material';

type Props = {
    /**
     * Статус окна.
     */
    open: boolean;

    /**
     * Закрытие диалогового окна.
     */
    close: () => void;

    /**
     * Подтверждение действия.
     */
    handleAgreeAction: () => void;
    loading?: boolean

    /**
     * Текст предупреждения
     */
    text?: string;
}

/**
 * Диалоговое окно удаления
 */
const DeleteDialog: FC<Props> = ({ open, close, loading, handleAgreeAction, text }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={close}
        aria-labelledby="responsive-dialog-title"
    >
    <DialogTitle id="responsive-dialog-title">
        {text ? text :"Вы уверены, что хотите удалить запись?"}
    </DialogTitle>
    <DialogActions>
        <Button autoFocus onClick={close}>
            Отмена
        </Button>
        <Button onClick={handleAgreeAction} disabled={loading} autoFocus>
            Удалить
        </Button>
    </DialogActions>
    </Dialog>
  );
}

export default DeleteDialog;
